import { render, staticRenderFns } from "./IndexExample.vue?vue&type=template&id=4f918459&scoped=true&"
import script from "./IndexExample.vue?vue&type=script&lang=js&"
export * from "./IndexExample.vue?vue&type=script&lang=js&"
import style0 from "./IndexExample.vue?vue&type=style&index=0&id=4f918459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f918459",
  null
  
)

export default component.exports